export enum ACTION {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  VIEW = "VIEW",
  VIEWCERTIFICATE = "VIEWCERTIFICATE",
  EDIT = "EDIT",
  SEND = "SEND",
  SENDAGAIN = "SENDAGAIN",
  DELETE = "DELETE",
  CANCEL = "CANCEL",
}

export enum ISSUE_DATE_SUGGESTION {
  ACCEPT = "ACCEPT",
  NEED_SUPPORT = "NEED_SUPPORT",
  REJECT = "REJECT",
}

export enum STATUS {
  VALID = "Valid",
  ACCEPTED = "Accepted",
  NEED_SUPPORT = "Need Support",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  CANCELED = "Canceled",
}